import React from "react";
import {
  Alert,
  Box,
  Typography,
} from "@mui/material";
import { FormProvider } from "react-hook-form";

import GraphicElements from "../../../styles/svg/graphic_elements.svg";
import mobileBg from "../../../styles/svg/login_bg_mobile.svg";
import { useResponsive } from "../../../hooks/useResponsive";
import { useAssets } from "../../../reactQuery/domainAssets";
import { getAPIBaseUrl } from "../../../utils/constants";
import TenantSiteName from "../../../components/TenantSiteName";
import { CustomButton } from "../../../components/Button/Button";
import { RFHTextField } from "../../../components/RFH";
import { PassWordRequirement } from "../../../components/ChangePassword";
import { useChangePasswordForm } from "../hooks/useChangePasswordForm";

function ChangePassword({ authToken, onSuccess, userData }) {
  const isMobile = useResponsive("down", "md");
  const { logo } = useAssets();
  const apiUrl = getAPIBaseUrl();
  const { methods, apiError, loading, allRequirementsMet, submit } =
    useChangePasswordForm({
      authToken,
      onSuccess,
    });
  const password = methods.watch("new_password") || "";
  const { handleSubmit } = methods;

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url(${isMobile ? mobileBg : GraphicElements})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "auto",
        minHeight: "100vh",
      }}
      disableGutters={true}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: 440,
          justifyContent: "center",
          padding: "40px 15px",
        }}
      >
        {logo ? (
          <img
            src={`${apiUrl}/${logo}`}
            alt="not found"
            width={isMobile ? 251 : ""}
            className="login_logo"
          />
        ) : (
          <TenantSiteName />
        )}
        <FormProvider {...methods}>
          <Box
            component="form"
            onSubmit={handleSubmit(submit)}
            noValidate
            className="change-password-form"
          >
            <Typography
              className="text-center black-primary-color create-new-password-title"
              component={"h1"}
              variant="h5"
            >
              Create New Password
            </Typography>
            <p className="create-new-password-info">
              Secure your account by setting a strong password.
            </p>
            {apiError && <Alert severity="error">{apiError}</Alert>}
            <PassWordRequirement password={password} className="reset-password-requirement-list" />
            <RFHTextField
              margin="normal"
              fullWidth
              name="email"
              label="Email"
              id="email"
              autoComplete="email"
              defaultPadding={false}
              value={userData.email}
              readOnly
              style={{ display: "none" }}
            />
            <RFHTextField
              margin="normal"
              required
              fullWidth
              name="new_password"
              label="New Password"
              type="password"
              id="new_password"
              defaultPadding={false}
              inputProps={{ autoFill: "new-password" }}
            />

            <RFHTextField
              margin="normal"
              required
              fullWidth
              id="confirmPassword"
              label={"Confirm Password"}
              name="confirmPassword"
              type="password"
              className="primary-input-field"
              defaultPadding={false}
              inputProps={{ autoFill: "new-password" }}
            />

          <CustomButton
            type="submit"
            fullWidth
            variant="contained"
            className="btn-blue"
            sx={{ mt: "14px", padding: "13px 16px" }}
            disabled={loading || !allRequirementsMet}
          >
            Save
          </CustomButton>
        </Box>
        </FormProvider>
      </Box>
    </Box>
  );
}

export default ChangePassword;
